<p-toast position="top-center"></p-toast>
<p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay">

    <div class="operational-loading-container text-center">
        <p-progressSpinner styleClass="operational-loading-spinner"></p-progressSpinner>
    </div>
</p-dialog>

<div class="container-fluid maap-root-container">
    <div class="operational-filter-toolbar">
        <div class="operational-filter-control" id="resolutionGrpApp">
            <app-resolution-code-select (resCodeselected)="resCodeselected($event)"></app-resolution-code-select>
        </div>
        <div class="operational-filter-control" id="serviceGrpApp">
            <app-service-grp-select (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
        </div>
        <div class="operational-filter-control operational-location-filter" id="locationApp">
            <app-location-select
              #locationSelectComp
              [user]="authService.user"
              [footprint]="footprint"
              [deId]="deId"
              [filter]="locationSelectFilter"
              (initComplete)="onLocationSelectInitialized($event)"
              (locationSelected)="onLocationChanged($event)">
            </app-location-select>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p-tabs [(value)]="activeTab" (onChange)="tabChanged($event)" class="tabViewStyle">
                <p-tablist>
                    <p-tab value="0">Global</p-tab>
                    <p-tab value="1">Comparison</p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="0">
                        <app-global-insights #global [lookbackPeriod]="selectedDays" [deId]="deId" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-global-insights> 
                    </p-tabpanel>
                    <p-tabpanel value="1">
                        <app-comparison-insights #comparison [lookbackPeriod]="selectedDays" [deId]="deId" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-comparison-insights>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
    </div>  
  </div>
